import { Box, Button, CircularProgress, Grid, TextField } from "@mui/material";
import Header from "components/Header";
import { BasePathProvider, useBasePath } from "components/Providers";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { save as saveEvaluation } from "store/evaluation/admin-evaluation";
import { useNavigate } from "react-router-dom";

export default function FeedbackForm({ feedback }) {
    const basePath = useBasePath()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { control, handleSubmit, formState } = useForm({
        defaultValues: {
            visit1Feedback: feedback?.evaluation?.visit1Feedback || "",
            visit2Feedback: feedback?.evaluation?.visit2Feedback || "",
            summativeFeedback: feedback?.evaluation?.summativeFeedback || "",
        },
    });

    const onSubmit = async (data) => {
        const payload = {
            id: feedback?.evaluation?.id,
            visit1Feedback: data.visit1Feedback,
            visit2Feedback: data.visit2Feedback,
            summativeFeedback: data.summativeFeedback,
        };

        await dispatch(saveEvaluation(payload));
        navigate(basePath)
    };

    return (
        <BasePathProvider value={`${basePath}/evaluation`}>

            <Header 
                title={!feedback?.evaluation?.feedback ? 
                    `Add Feedback for ${feedback.lastName}, ${feedback.firstName}` : 
                    `Edit Feedback for ${feedback.lastName}, ${feedback.firstName}`} 
                small 
                close 
                borderBottom 
            />
            <Box data-component="EvaluationForm" component="form" onSubmit={handleSubmit(onSubmit)} py={2} px={1}>

                <Grid container spacing={1.5}>
                    <Grid item xs={12}>
                        <Controller
                            name="visit1Feedback"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    variant="outlined"
                                    label="Site Visit 1 Feedback"
                                    multiline
                                    fullWidth
                                    error={Boolean(formState.errors.feedback)}
                                    helperText={formState.errors.feedback?.message}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Controller
                            name="visit2Feedback"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    variant="outlined"
                                    label="Site Visit 2 Feedback"
                                    multiline
                                    fullWidth
                                    error={Boolean(formState.errors.feedback)}
                                    helperText={formState.errors.feedback?.message}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Controller
                            name="summativeFeedback"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    variant="outlined"
                                    label="Summative Visit Feedback"
                                    multiline
                                    fullWidth
                                    error={Boolean(formState.errors.feedback)}
                                    helperText={formState.errors.feedback?.message}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button 
                        type="submit" 
                        size="medium" 
                        variant="contained" 
                        color="primary"
                        disabled={formState.isSubmitting || !formState.isDirty}
                        startIcon={formState.isSubmitting && <CircularProgress size={20} />}
                    >
                        Save
                    </Button>
                </Box>
            </Box>
        </BasePathProvider>
    )
}
